<template>
  <div class='need-container'>
    <div class='need'>
      <div class='need-title'>{{ title }}</div>
      <div class='need-list' :class="{'align-items': alignItems}">
        <div class='logo-only' v-if="elements.length === 1 && !elements[0].name">
            <img class='logo' :src='elements[0].logo'/>
        </div>
        <div v-else class='need-list-item' v-for='element in elements' :key='element.id'>
          <div class='logo-container'>
            <img class='logo' :class="{ big: title === 'PUBLIC' }" :src='element.logo'/>
          </div>
          <div class='name'>{{ element.name }}</div>
        </div>
      </div>
      <div id="separator" :class="{hidden: title === 'OUTILS'}" class="separator"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NeedTrainingComponent',
  props: ['title', 'elements', 'alignItems']
}
</script>

<style lang='scss' scoped>

.separator {
  margin: 0 auto;
  width: 35%;
  margin-top: 25px;
  margin-bottom: 25px;

  @include media(tablet) {
    width: 122px;
    border-bottom: 1px solid #aaa3;
  }

  &.hidden {
    border-bottom: none;
  }
}

.need-container {
  height: 100%;
  width: 100%;

  .need {
    height: 100%;
    width: 100%;

    margin-bottom: 12px;

    @include media (phone) {
      margin: 0px auto;
    }

    .need-title {
      text-align: center;
      height: 32px;
      font-size: 1.1rem;
      font-weight: 900;
      letter-spacing: -0.08px;
      line-height: 32px;
      padding-bottom: 12px;
      position: relative;
      margin-bottom: 12px;
      margin-top: 12px;

      @include media(phone) {
        margin-top: unset;
      }
    }
    .need-list {
      align-items: center;
      display: flex;
      justify-content: flex-start;
      height: 70%;
      text-align: center;
      width: 100%;
      flex-direction: column;

      @include media(tablet) {
        &.align-items {
          align-items: flex-start !important;
        }
      }
      .logo-only{
        width: 80%;
        position: relative;
        &:after, &:before {
          font-size: 0.8rem;
          font-weight: 500;
          bottom: 12px;
          @include media (phone) {
            bottom: 8px;
            font-size: 0.8rem;
          }
        }
        &:before {
          content: 'Théorique';
          position: absolute;
          left : -12px;
          background: white;
          @include media (phone) {
            left: -18px;
          }
        }
        &:after {
          content: 'Pratique';
          position: absolute;
          right : -8px;
          background: white;
          @include media (phone) {
            right: -8px;
          }
        }
        img{
          width: 100%;
        }
      }
      .need-list-item {
        margin: 6px 10px;
        max-width: 70%;
        width: 292px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        text-align: left;

        .logo-container {
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 12px;
          min-width: 32px;

          .logo {
            height: 26px;
            max-width: 24px;

            @include media (phone) {
              height: 24px;
              max-width: 24px;
            }

            &.big {
              height: 32px;
              width: 32px;
              max-width: unset;
            }
          }
        }

        .name {
          font-size: 0.75rem;
          font-weight: 500;

          @include media (phone) {
            font-size: 0.75rem;
          }
        }
      }
    }
  }
}
</style>
